import { useContext } from 'react';
import AppContext from '../../../AppContext';
import RowHelmet from '../RowHelmet';
import styles from './LineOfBusiness.module.css';
import { DollarFormat, RatioFormat } from '../../format';
import BlankRow from '../BlankRow/BlankRow';
import ResultRowData from '../ResultRowData';
import { DataResult } from '../../model/DataResult';

function hasAnyOutsideBenchmarks(resultMap: { [p: string]: DataResult } | undefined) {
  if (!resultMap) return false;

  return (
    resultMap['currentYearNetOperating']?.outsideBenchmark ||
    resultMap['netPremiumChange']?.outsideBenchmark ||
    resultMap['currentYearNetPremium']?.outsideBenchmark ||
    resultMap['priorYearNetPremium']?.outsideBenchmark ||
    resultMap['netOperatingChange']?.outsideBenchmark ||
    resultMap['priorYearNetOperating']?.outsideBenchmark ||
    resultMap['currentYearReturnOnRevenue']?.outsideBenchmark ||
    resultMap['currentYearLossRatio']?.outsideBenchmark ||
    resultMap['priorYearReturnOnRevenue']?.outsideBenchmark ||
    resultMap['currentYearExpenseRatio']?.outsideBenchmark ||
    resultMap['priorYearLossRatio']?.outsideBenchmark
  );
}

export default function LineOfBusinessRow({
  sectionKey,
  rowKey,
  label,
  benchmark,
  rowClass,
  rowType,
  resultMap
}: ResultRowData) {
  const { showBenchmark } = useContext(AppContext);
  const id = `${sectionKey}-${rowKey}`;

  if (rowType === 'BLANK') {
    return <BlankRow />;
  } else {
    return (
      <div
        id={id}
        data-testid={id}
        className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${
          rowClass === 'BOLD' ? styles.bold : ''
        } ${rowClass === 'INDENT' ? styles.indent : ''}`}>
        <RowHelmet
          label={label}
          benchmarkText={benchmark}
          isOutsideBenchmark={hasAnyOutsideBenchmarks(resultMap)}
        />
        <RatioFormat {...(resultMap && resultMap['netPremiumChange'])} showDefaultValue={true} />
        <DollarFormat {...(resultMap && resultMap['currentYearNetPremium'])} />
        <DollarFormat {...(resultMap && resultMap['priorYearNetPremium'])} />
        <RatioFormat {...(resultMap && resultMap['netOperatingChange'])} showDefaultValue={true} />
        <DollarFormat {...(resultMap && resultMap['currentYearNetOperating'])} />
        <DollarFormat {...(resultMap && resultMap['priorYearNetOperating'])} />
        <RatioFormat
          {...(resultMap &&
            (resultMap['currentYearReturnOnRevenue'] || resultMap['currentYearLossRatio']))}
        />
        <RatioFormat
          {...(resultMap &&
            (resultMap['priorYearReturnOnRevenue'] || resultMap['priorYearLossRatio']))}
        />
        <RatioFormat {...(resultMap && resultMap['currentYearExpenseRatio'])} />
        <RatioFormat {...(resultMap && resultMap['priorYearExpenseRatio'])} />
      </div>
    );
  }
}
